// src/components/StaffChipSelect.tsx
import React from "react";
import {
  Box,
  Typography,
  Stack,
  Chip,
  CircularProgress,
} from "@mui/material";
import { Staff } from "../api/staff";

type StaffChipSelectProps = {
  staff: Staff[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  loading?: boolean;
};



const StaffChipSelect: React.FC<StaffChipSelectProps> = ({
  staff,
  selectedIds,
  onChange,
  loading,
}) => {
  const toggle = (id: string) => {
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((x) => x !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  };

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="subtitle2" gutterBottom>
        Assignable Staff
      </Typography>

      {loading && staff.length === 0 ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <CircularProgress size={18} />
          <Typography variant="body2" color="text.secondary">
            Loading staff...
          </Typography>
        </Box>
      ) : staff.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No staff members found. Configure staff first.
        </Typography>
      ) : (
        <Stack direction="row" flexWrap="wrap" gap={1}>
          {staff.map((member) => {
            const selected = selectedIds.includes(member.staff_id);
            return (
              <Chip
                key={member.staff_id}
                label={member.full_name}
                color={selected ? "primary" : "default"}
                variant={selected ? "filled" : "outlined"}
                size="small"
                onClick={() => toggle(member.staff_id)}
              />
            );
          })}
        </Stack>
      )}
    </Box>
  );
};

export default StaffChipSelect;
